import { Helmet } from "react-helmet";
import Section1 from "./Section1";
import Section2 from "./Section2";
import Section3 from "./Section3";
import Section4 from "./Section4";
import Section5 from "./Section5";
import Section6 from "./Section6";

export default function InfluencerMarketing() {
  return (
    <div className="Influencer-Marketing pt-[160px] sm:pt-0">
      <Helmet>
        <title>Top Influencer Marketing Agency | Expert Outreach & Management</title>
        <meta
        name="description"
        content="Mean3 is a leading influencer marketing agency offering influencer outreach, consulting, and management services. Hire influencers that drive real results."
        />
      </Helmet>
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
      <Section5 />
      <Section6 />
    </div>
  );
}
